export default __webpack_public_path__ + "static/media/GBC.ede16dac.png";